import { render, staticRenderFns } from "./SkillsSection.vue?vue&type=template&id=2245496e&scoped=true&"
import script from "./SkillsSection.vue?vue&type=script&lang=js&"
export * from "./SkillsSection.vue?vue&type=script&lang=js&"
import style0 from "./SkillsSection.vue?vue&type=style&index=0&id=2245496e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2245496e",
  null
  
)

export default component.exports